<template>
  <div class="search absolute top-0 left-0 bg-white h-full w-full">
    <input ref="search" v-model="searchTerm" autocomplete="off" class="py-2 h-full w-full mx-4" type="text" placeholder="Search" tabindex="0" @keyup.esc="close">
    <ul v-if="searching" class="w-1/2 absolute bg-white border-b border-t border-black">
      <li class="mx-4 my-4 pulse" v-if="searching">Searching...</li>
    </ul>
    <ul @click="close" v-else-if="searchResults" class="results w-1/2 absolute bg-white border-b border-t border-black">
      <li class="mx-4 my-4" v-for="(result, count) in searchResults" :key="count">
        <router-link :to="getLink(result)">
          {{ getFieldByLang(result, 'title', lang) }} <span v-if="result.date" class="uppercase inline-block px-2">({{ formatDate(result.date) }})</span>
          <span class="uppercase text-sm f-serif pl-1">{{ getEventType(result) }}</span>
        </router-link>
      </li>
      <li class="mx-4 my-4" v-if="searchResults.length == 0">Nothing found...</li>
    </ul>
    <div class="flex h-full absolute top-0 right-0 items-center mx-4 cursor-pointer" @click="close">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="1.3306" y1="1.09957" x2="27.1254" y2="26.8944" stroke="black"/>
      <line x1="27.1255" y1="1.80668" x2="1.33074" y2="27.6015" stroke="black"/>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
export default {

  name: 'Search',

  data () {
    return {
      searching: false
    }
  },

  props: ['show'],

  created () {
    this.debouncedSearch = debounce(this.search, 500)
  },

  computed: {
    ...mapState(['lang', 'searchResults']),
    searchTerm: {
      get () {
        return this.$store.state.searchTerm
      },
      set (value) {
        this.$store.commit('SET_SEARCH_TERM', value)
      }
    }
  },

  methods: {
    ...mapActions(['search']),
    close () {
      console.log('hide')
      this.searching = false
      this.$emit('hide')
    },
    getLink (item) {
      if (item.blueprint === 'Artist') {
        return `/artists/${item.slug}`
      } else {
        return `/calendar/${item.date}/${item.slug}`
      }
    },
    getEventType (item) {
      if (item.blueprint === 'Event Group') {
        return 'Event'
      } else {
        return item.blueprint
      }
    }
  },

  watch: {
    searchTerm () {
      this.results = null
      if (this.searchTerm && this.searchTerm != '') {
        this.searching = true
        this.debouncedSearch()
      } else {
        this.searching = false
      }
    },
    searchResults () {
      if (this.searchResults) {
        this.searching = false
      }
    },
    show () {
      if (this.show) {
        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
  .results
    max-height 60vh
    overflow-y auto
    
    a:hover, a.router-link-active
      color red
</style>